import { FormControlLabel } from '@material-ui/core'
import MuiCheckbox, { CheckboxProps as Props } from '@material-ui/core/Checkbox'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Check from '../../stories/assets/check.svg'

export type StyledCheckbox = {
  label?: string
}

export type CheckboxProps = Props & StyledCheckbox

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:hover': {
        backgroundColor: 'transparent'
      },
      '&.Mui-disabled': {
        background: theme.palette.grey[500],
        borderRadius: 2,
        width: 18,
        height: 18,
        margin: 9
      }
    },
    icon: {
      borderRadius: 2,
      width: 18,
      height: 18,
      boxShadow: `inset 0 0 0 1px ${theme.palette.grey[600]}, inset 0 -1px 0 ${theme.palette.grey[600]}`,
      backgroundColor: theme.palette.common.white
    },
    checkedIcon: {
      borderRadius: 2,
      backgroundColor: theme.palette.primary.main,
      '&:before': {
        display: 'block',
        width: 18,
        height: 18,
        backgroundImage: `url(${Check})`,
        content: '""',
        backgroundPosition: '50% 20%'
      }
    },
    boxDisabled: {},
    label: {
      ...theme.typography.body2,
      color: theme.palette.grey[900]
    }
  })
)

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const classes = useStyles()
  const { label, ...rest } = props
  return (
    <div>
      <FormControlLabel
        classes={{ label: classes.label }}
        control={
          <MuiCheckbox
            classes={{ root: classes.root }}
            checkedIcon={
              rest.disabled ? (
                <span />
              ) : (
                <span className={classes.checkedIcon} />
              )
            }
            icon={<span className={classes.icon} />}
            {...rest}
          />
        }
        label={label}
      />
    </div>
  )
}

export default Checkbox